module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-modal"
  }, [(!_vm.success) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.changePassword($event)
      }
    }
  }, [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("Reset your password")])], 1), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contributor ? _vm.contributorEmail : _vm.email),
      expression: "contributor ? contributorEmail : email"
    }],
    attrs: {
      "type": "email",
      "placeholder": _vm.$pgettext('password popup', 'Email'),
      "disabled": _vm.contributor
    },
    domProps: {
      "value": (_vm.contributor ? _vm.contributorEmail : _vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contributor ? _vm.contributorEmail : _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "password"
  }, [_c('a', {
    staticClass: "show",
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.togglePassword($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]), _vm._v(" "), (_vm.showPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.$pgettext('password popup', 'New password')
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    attrs: {
      "type": "password",
      "placeholder": _vm.$pgettext('password popup', 'New password')
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [(_vm.showPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.$pgettext('password popup', 'Confirm new password')
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    attrs: {
      "type": "password",
      "placeholder": _vm.$pgettext('password popup', 'Confirm new password')
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.passwordOk === false) ? _c('p', {
    staticClass: "error"
  }, [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("\n        Passwords must be the same\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error"
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("\n        An error has occured. Please try again.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "keyboard-submit-bug-fix"
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "high"
  }, [_c('img', {
    attrs: {
      "src": "/img/load.gif"
    }
  })]) : _c('p', [_c('button', {
    on: {
      "click": function($event) {
        _vm.changePassword()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1), _vm._v(" "), _c('button', {
    staticClass: "light",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)])]) : _c('div', [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("One last step...")])], 1), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("\n        If you are a contributor, you will receive an email.\n      ")])], 1), _vm._v(" "), _c('p', [_c('strong', [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("\n          Click on the link inside the email to change your password.\n        ")])], 1)]), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("\n        Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo‑parapente.com\n      ")])], 1), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e75d856"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/password.vue
// module id = 346
// module chunks = 1